import { Component, OnInit, ViewChild } from '@angular/core';
import { AnalyticsService } from '../../services/analytics.service';
import { ModalService } from 'ng-bootstrap-modal';
import { ExcelService } from '../../services/excel.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DataTableDirective } from 'angular-datatables';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { TabsetComponent, TabDirective } from 'ngx-bootstrap/tabs';
class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}
@Component({
    selector: 'app-deshboard',
    templateUrl: './deshboard.component.html',
    styleUrls: ['./deshboard.component.scss']
})
export class DeshboardComponent implements OnInit {
    selectedSection = 'todaysAppointments';
    @ViewChild('tabset') tabset: TabsetComponent;
    dtCompleteAppointmentOptions: DataTables.Settings = {};
    dtPendingAppointmentOptions: DataTables.Settings = {};
    dtCancelAppointmentOptions: DataTables.Settings = {};
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;
    dtTrigger: Subject<DeshboardComponent> = new Subject();
    public reports = [];
    public todayAppointmentList = [];
    public completedAppointments = [];
    public pendingAppointments = [];
    public cancelAppointments = [];
    p: number = 1;
    total: number;
    statusMessage: string = "Loading data please wait...";
    allAppointments: number = 0;
    todaysAppointments: number = 0;
    futureAppointments: number = 0;
    allTransactions: number = 0;
    todaysTransactionslist: number = 0;
    headerText: string = "";
    isViewappointment: boolean = false;
    isAppointmentDetailReport: boolean = false;
    isViewTransactions: boolean = false;
    isViewStaffs: boolean = false;
    isViewUsers: boolean = false;
    isViewAllappointment: boolean = false;
    isViewAllTransactions: boolean = false;
    isViewPatients: boolean = false;
    doctorCount: number = 0;
    staffCount: number = 0;
    patientCount: number = 0;
    isdisplaysearch: boolean = true;
    isSlide: boolean = false;
    selectedTab: string;
    sectionType: string = 'appointment';
    constructor(private router: Router, private http: HttpClient, private ngxService: NgxUiLoaderService, private _analyticsService: AnalyticsService, private modalService: ModalService, private excelService: ExcelService) {

    }

    ngOnInit() {
        this.ngxService.start();
        this.gettodaysAppointemts();
        this.getDeshboardUsers();
        this.isViewTransactions = false;
        this.isViewUsers = false;
        this.isViewStaffs = false;
        this.isViewPatients = false;
        this.isAppointmentDetailReport = false;
        this.headerText = "Today's Appointments"
        this.isViewappointment = true;

    }

    ngAfterViewInit(): void {
        this.dtTrigger.next();
    }

    ngOnDestroy(): void {
        // Do not forget to unsubscribe the event
        this.dtTrigger.unsubscribe();
    }
    onSelectTab(data: TabDirective) {
        console.log('data.heading ', data.heading);
        if (this.sectionType != data.heading) {
            console.log('if block ');
            if (data.heading == 'Complete appointments') {
                this.getAllAppointentsType(data.heading);
            }
            else if (data.heading == 'Pending appointments') {
                this.getAllAppointentsType(data.heading);
            }
            else if (data.heading == 'Cancel appointments') {
                this.getAllAppointentsType(data.heading);
            }

            this.selectedTab = data.heading;
        }
        else {
            console.log('else block ');
            this.selectedTab = data.heading;
        }

    }
    activeTab(id) {
        this.tabset.tabs[id].active = true;
    }
    rerender(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
        });
    }

    showReportForm() {
        this.router.navigateByUrl('/generate-report');
    }
    showPatientReportForm() {
        this.router.navigateByUrl('/generate-report');
    }
    getPatientsList() {
        this.reports = [];
        this.sectionType = 'users';
        this.isdisplaysearch = false;
        this.isViewappointment = false;
        this.isViewAllappointment = false;
        this.isViewTransactions = false;
        this.isViewAllTransactions = false;
        this.isViewUsers = false;
        this.isViewStaffs = false;
        this.isViewPatients = true;
        this.headerText = "";
        this.headerText = "Total Patients"
        this.isAppointmentDetailReport = false;
        let loginUser = JSON.parse(localStorage.getItem('currentUser'));
        const that = this;
        this.dtOptions = {
            "order": [[0, 'desc']],
            responsive: true,
            serverSide: true,
            processing: true,
            ajax: (dataTablesParameters: any, callback) => {
                dataTablesParameters["token"] = loginUser.token;
                dataTablesParameters["userid"] = loginUser.userDetail.id;
                that.http
                    .post<DataTablesResponse>(
                        environment.apiURL + '/api/AdminPatientsList',
                        dataTablesParameters, {}
                    ).subscribe(resp => {
                        // that.reports = resp.data;
                        that.reports = this.validateUsersProfileImages(resp.data);
                        console.log('res in patient', this.reports);
                        callback({
                            recordsTotal: resp.recordsTotal,
                            recordsFiltered: resp.recordsFiltered,
                            data: []
                        });
                    });
            },
            columns: [
                { data: 'createdDate' },
                { data: 'profileImage', searchable: false, orderable: false },
                { data: 'patientName' },
                { data: 'gender' },
                { data: 'patientAge' },
                { data: 'mobile' },
                { data: 'email' },
                { data: 'cityName' }
            ]
        };
    }

    // mthod for checking the profile images are null or not.
    validateUsersProfileImages(users: any) {
        for (const user in users) {
            if (users[user].profileImage) {
                if (users[user].profileImage.includes("null") == true) {
                    users[user].profileImage = '';
                }
            }
        }
        console.log('items ', users);
        return users;
    }


    getAllAppointemts() {
        this.reports = [];
        this.sectionType = 'appointments';
        this.isdisplaysearch = false;
        this.isViewappointment = false;
        this.isViewAllappointment = true;
        this.isViewTransactions = false;
        this.isViewAllTransactions = false;
        this.isViewUsers = false;
        this.isViewStaffs = false;
        this.isViewPatients = false;
        this.headerText = "";
        this.headerText = "All Appointments"
        this.isAppointmentDetailReport = false;
        let loginUser = JSON.parse(localStorage.getItem('currentUser'));
        debugger
        const that = this;
        this.dtOptions = {
            "order": [[0, 'desc']],
            responsive: true,
            serverSide: true,
            processing: true,
            ajax: (dataTablesParameters: any, callback) => {
                dataTablesParameters["token"] = loginUser.token;
                dataTablesParameters["userid"] = loginUser.userDetail.id;
                that.http
                    .post<DataTablesResponse>(
                        environment.apiURL + '/api/getAllappointmentReport',
                        dataTablesParameters, {}
                    ).subscribe(resp => {
                        for(let index = 0;index<resp.data.length;index++){
                            if(resp.data[index].email == 'null'){
                                resp.data[index].email = '';
                            }
                        }
                        that.reports = resp.data;
                        callback({
                            recordsTotal: resp.recordsTotal,
                            recordsFiltered: resp.recordsFiltered,
                            data: []
                        });
                    });
            },
            columns: [
                { data: 'appointmentDateAndTime' },
                { data: 'patientName' },
                { data: 'patientAge' },
                { data: 'email' },
                { data: 'mobile' },
                { data: 'doctorName' },
                { data: 'appointmentStatus' }
            ]
        };
    }

    gettodaysAppointemts() {
        console.log('get today appointments');
        this.reports = [];
        this.sectionType = 'appointments';
        this.isdisplaysearch = true;
        this.isViewappointment = true;
        this.isViewTransactions = false;
        this.isViewAllTransactions = false;
        this.isViewAllappointment = false;
        this.isViewUsers = false;
        this.isViewStaffs = false;
        this.isViewPatients = false;
        this.headerText = "";
        this.isAppointmentDetailReport = false;
        this.headerText = "Today's Appointments"
        this._analyticsService.gettodayAppointments()
            .subscribe(
                (employeeData) => {
                    if (employeeData == null) {
                        this.statusMessage = "Employee Id does not exist..";
                    }
                    else if(employeeData && employeeData.response){
                        console.log('employeeData ',employeeData);
                        for(let index = 0;index<employeeData.response.appointmentList.length;index++){
                            if(employeeData.response.appointmentList[index].email == 'null'){
                                employeeData.response.appointmentList[index].email = '';
                            }
                        }
                        this.reports = employeeData;
                        this.allAppointments = employeeData.response.allAppointments;
                        this.todaysAppointments = employeeData.response.todaysAppointments;
                        this.futureAppointments = employeeData.response.FutureAppointments;
                        this.todayAppointmentList = employeeData.response.appointmentList;

                        this.ngxService.stop();
                    }
                    this.ngxService.stop();
                    console.log(this.reports);
                },
                (error) => {
                    this.statusMessage = "Problem with the service. Please try again after sometime";
                    console.log(error);
                }

            );

    }

    getFutureAppointments() {
        this.reports = [];
        this.sectionType = 'appointments';
        this.isdisplaysearch = true;
        this.isViewappointment = true;
        this.isViewTransactions = false;
        this.isViewAllTransactions = false;
        this.isViewAllappointment = false;
        this.isViewUsers = false;
        this.isViewStaffs = false;
        this.isViewPatients = false;
        this.reports = [];
        this.headerText = "";
        this.isAppointmentDetailReport = false;
        this.headerText = "Upcoming Appointments"
        this._analyticsService.getFutureAppointments()
            .subscribe(
                (employeeData) => {
                    if (employeeData == null) {
                        this.statusMessage = "Employee Id does not exist..";
                    }
                    else {
                        this.reports = employeeData
                    }

                    console.log(this.reports);
                },
                (error) => {
                    this.statusMessage = "Problem with the service. Please try again after sometime";
                    console.log(error);
                }

            );

    }

    getTransaactions() {
        this.reports = [];
        this.sectionType = 'transcation';
        this.isdisplaysearch = false;
        this.isViewappointment = false;
        this.isViewTransactions = false;
        this.isViewAllTransactions = true;
        this.isViewUsers = false;
        this.isViewAllappointment = false;
        this.isViewStaffs = false;
        this.isViewPatients = false;
        this.headerText = "";
        this.isAppointmentDetailReport = false;
        this.headerText = "Payment Transactions"
        let loginUser = JSON.parse(localStorage.getItem('currentUser'));
        const that = this;
        this.dtOptions = {
            "order": [[0, 'desc']],
            responsive: true,
            serverSide: true,
            processing: true,
            ajax: (dataTablesParameters: any, callback) => {
                dataTablesParameters["token"] = loginUser.token;
                dataTablesParameters["userid"] = loginUser.userDetail.id;
                that.http
                    .post<DataTablesResponse>(
                        environment.apiURL + '/api/getAllTransactionDetails',
                        dataTablesParameters, {}
                    ).subscribe(resp => {
                        that.reports = resp.data;
                        callback({
                            recordsTotal: resp.recordsTotal,
                            recordsFiltered: resp.recordsFiltered,
                            data: []
                        });
                    });
            },
            columns: [
                { data: 'createddatetime'},
                { data: 'customername' },
                { data: 'customerphone' },
                { data: 'customercountry' },
                { data: 'customeraddress' },
                { data: 'customercity' },
                { data: 'customerzip' },
                { data: 'customercredittype' },
                { data: 'transactioncurrency' },
                { data: 'transactionamount' },
            ]
        };
    }

    getTodaysTransaactions() {
        this.reports = [];
        this.sectionType = 'transcation';
        this.isdisplaysearch = true;
        this.isViewappointment = false;
        this.isViewTransactions = true;
        this.isViewAllTransactions = false;
        this.isViewUsers = false;
        this.isViewStaffs = false;
        this.isViewPatients = false;
        this.isViewAllappointment = false;
        this.headerText = "";
        this.isAppointmentDetailReport = false;
        this.headerText = "Today's Payment Transactions"
        this._analyticsService.getTransactions()
            .subscribe(
                (employeeData) => {
                    if (employeeData == null) {
                        this.statusMessage = "Employee Id does not exist..";
                    }
                    else {
                        this.reports = employeeData.response.todaysTransactionlist
                    }
                },
                (error) => {
                    this.statusMessage = "Problem with the service. Please try again after sometime";
                    console.log(error);
                }
            );
    }

    getDeshboardUsers() {
        this._analyticsService.getDeshboardUsers()
            .subscribe(
                (employeeData) => {
                    if (employeeData == null) {
                        this.statusMessage = "Employee Id does not exist..";
                    }
                    else {
                        this.doctorCount = employeeData.response.userdetails.doctors
                        this.staffCount = employeeData.response.userdetails.staff
                        this.patientCount = employeeData.response.userdetails.patients
                        this.allTransactions = employeeData.response.userdetails.allTransaction
                        this.todaysTransactionslist = employeeData.response.userdetails.toDaysTransaction

                    }
                },
                (error) => {
                    this.statusMessage = "Problem with the service. Please try again after sometime";
                    console.log(error);
                }
            );
    }

    getDoctorsList() {
        this.reports = [];
        this.sectionType = 'users';
        this.isViewAllappointment = false;
        this.isdisplaysearch = true;
        this.isViewappointment = false;
        this.isViewTransactions = false;
        this.isViewAllTransactions = false;
        this.isViewStaffs = false;
        this.isViewPatients = false;
        this.isViewUsers = true;
        this.isViewPatients = false;
        this.isAppointmentDetailReport = false;
        this.headerText = "";
        this.headerText = "Total Doctors"
        this._analyticsService.getDoctorsList()
            .subscribe(
                (employeeData) => {
                    if (employeeData == null) {
                        this.statusMessage = "Employee Id does not exist..";
                    }
                    else {
                        this.reports = employeeData.response.doctotList
                    }

                },
                (error) => {
                    this.statusMessage = "Problem with the service. Please try again after sometime";
                    console.log(error);
                }
            );
    }

    getStaffList() {
        this.reports = [];
        this.sectionType = 'users';
        this.isViewAllappointment = false;
        this.isdisplaysearch = true;
        this.isViewappointment = false;
        this.isViewTransactions = false;
        this.isViewAllTransactions = false;
        this.isViewUsers = false;
        this.isViewStaffs = true;
        this.isViewPatients = false;
        this.headerText = "";
        this.isAppointmentDetailReport = false;
        this.headerText = "Total Staffs"
        this._analyticsService.getStaffList()
            .subscribe(
                (employeeData) => {
                    if (employeeData == null) {
                        this.statusMessage = "Employee Id does not exist..";
                    }
                    else {
                        this.reports = employeeData.response.staffList
                    }

                },
                (error) => {
                    this.statusMessage = "Problem with the service. Please try again after sometime";
                    console.log(error);
                }
            );
    }

    getAllAppointentsType(aptType) {
        // this.selectedTab = 'Complete appointments';
        this.selectedTab = aptType;
        this.sectionType = 'appointments';
        this.reports = [];
        this.isdisplaysearch = false;
        this.isViewappointment = false;
        this.isAppointmentDetailReport = true;
        this.isViewTransactions = false;
        this.isViewUsers = false;
        this.isViewStaffs = false;
        this.isViewPatients = false;
        this.headerText = "";
        this.headerText = "All Appointments Details";
        let loginUser = JSON.parse(localStorage.getItem('currentUser'));
        const that = this;
        this.dtCompleteAppointmentOptions = {
            "order": [[0, 'desc']],
            responsive: true,
            serverSide: true,
            processing: true,
            destroy: true,
            ajax: (dataTablesParameters: any, callback) => {
                dataTablesParameters["token"] = loginUser.token;
                dataTablesParameters["userid"] = loginUser.userDetail.id;
                dataTablesParameters["status"] = '1';
                that.http
                    .post<DataTablesResponse>(
                        environment.apiURL + '/api/getAllAppointmentsByStatus',
                        dataTablesParameters, {}
                    ).subscribe(resp => {
                        that.completedAppointments = resp.data;
                        callback({
                            recordsTotal: resp.recordsTotal,
                            recordsFiltered: resp.recordsFiltered,
                            data: []
                        });
                    });
            },
            columns: [
                { data: 'appointmentdateandtime' },
                { data: 'patientname' },
                { data: 'patientage' },
                { data: 'email' },
                { data: 'mobile' },
                { data: 'doctorname' },
                { data: 'patientwaitingtime' },
            ]
        };


        this.dtPendingAppointmentOptions = {
            "order": [[0, 'desc']],
            "autoWidth": false,
            responsive: true,
            serverSide: true,
            processing: true,
            destroy: true,
            ajax: (dataTablesParameters: any, callback) => {
                dataTablesParameters["token"] = loginUser.token;
                dataTablesParameters["userid"] = loginUser.userDetail.id;
                dataTablesParameters["status"] = '0';
                that.http
                    .post<DataTablesResponse>(
                        environment.apiURL + '/api/getAllAppointmentsByStatus',
                        dataTablesParameters, {}
                    ).subscribe(resp => {
                        console.log('pending appointments ', resp);
                        that.pendingAppointments = resp.data;
                        callback({
                            recordsTotal: resp.recordsTotal,
                            recordsFiltered: resp.recordsFiltered,
                            data: []
                        });
                    });
            },
            columns: [
                { data: 'appointmentdateandtime' },
                { data: 'patientname' },
                { data: 'patientage' },
                { data: 'email' },
                { data: 'mobile' },
                { data: 'doctorname' },
                { data: 'patientwaitingtime' },
                { data: 'status' }
            ]
        };


        this.dtCancelAppointmentOptions = {
            "order": [[0, 'desc']],
            "autoWidth": false,
            responsive: true,
            serverSide: true,
            processing: true,
            destroy: true,
            ajax: (dataTablesParameters: any, callback) => {
                dataTablesParameters["token"] = loginUser.token;
                dataTablesParameters["userid"] = loginUser.userDetail.id;
                dataTablesParameters["status"] = '2';
                that.http
                    .post<DataTablesResponse>(
                        environment.apiURL + '/api/getAllAppointmentsByStatus',
                        dataTablesParameters, {}
                    ).subscribe(resp => {
                        console.log('cancel appointments ', resp);
                        that.cancelAppointments = resp.data;
                        callback({
                            recordsTotal: resp.recordsTotal,
                            recordsFiltered: resp.recordsFiltered,
                            data: []
                        });
                    });
            },
            columns: [
                { data: 'appointmentdateandtime' },
                { data: 'patientname' },
                { data: 'patientage' },
                { data: 'email' },
                { data: 'mobile' },
                { data: 'doctorname' },
                { data: 'patientwaitingtime' },
                { data: 'comment' },
            ]
        };

    }

    resetAppointmentsTablesData(){
        this.dtCompleteAppointmentOptions = {};
        this.dtPendingAppointmentOptions = {};
        this.dtCancelAppointmentOptions = {};
    }

    onSearchChange(searchValue: string) {
        if (this.isViewappointment) {
            this._analyticsService.searchAppointments(searchValue)
                .subscribe(
                    (employeeData) => {
                        if (employeeData == null) {
                            this.statusMessage = "Employee Id does not exist..";
                        }
                        else {
                            this.reports = employeeData
                            this.allAppointments = employeeData.response.allAppointments;
                            this.todaysAppointments = employeeData.response.todaysAppointments;
                            this.futureAppointments = employeeData.response.FutureAppointments;
                        }
                        console.log(this.reports);
                    },
                    (error) => {
                        this.statusMessage = "Problem with the service. Please try again after sometime";
                        console.log(error);
                    }
                );
        }

        else if (this.isViewTransactions) {
            this._analyticsService.searchTransactions(searchValue)
                .subscribe(
                    (employeeData) => {
                        if (employeeData == null) {
                            this.statusMessage = "Employee Id does not exist..";
                        }
                        else {
                            this.reports = employeeData.response.transactionDetails
                            this.allTransactions = employeeData.response.totalTransactions
                            this.todaysTransactionslist = employeeData.response.todaysTransactions
                        }
                        console.log(this.reports);
                    },
                    (error) => {
                        this.statusMessage = "Problem with the service. Please try again after sometime";
                        console.log(error);
                    }

                );

        }

        else if (this.isViewUsers) {
            this._analyticsService.searchDoctors(searchValue, 2)
                .subscribe(
                    (employeeData) => {
                        if (employeeData == null) {
                            this.statusMessage = "Employee Id does not exist..";
                        }
                        else {
                            this.reports = employeeData.response.doctotList
                        }
                    },
                    (error) => {
                        this.statusMessage = "Problem with the service. Please try again after sometime";
                        console.log(error);
                    }
                );
        }

        else if (this.isViewStaffs) {
            this._analyticsService.searchDoctors(searchValue, 3)
                .subscribe(
                    (employeeData) => {
                        if (employeeData == null) {
                            this.statusMessage = "Employee Id does not exist..";
                        }
                        else {
                            this.reports = employeeData.response.doctotList
                        }
                    },
                    (error) => {
                        this.statusMessage = "Problem with the service. Please try again after sometime";
                        console.log(error);
                    }
                );
        }

        else if (this.isViewPatients) {
            this._analyticsService.getPatientsList()
                .subscribe(
                    (employeeData) => {
                        if (employeeData == null) {
                            this.statusMessage = "Patients does not exist..";
                        }
                        else {
                            if (searchValue) {
                                console.log('Patient searchValue', searchValue)
                                this.reports = employeeData.response.patientList.filter(t => {
                                    let patientName = (t.patientName != null && t.patientName.toLowerCase().indexOf(searchValue.toLowerCase()) > -1);
                                    let gender = (t.gender != null && t.gender.toLowerCase() == searchValue.toLowerCase());
                                    let cityName = (t.cityName != null && t.cityName.toLowerCase() == searchValue.toLowerCase());
                                    let email = (t.email != null && t.email.toLowerCase().indexOf(searchValue.toLowerCase()) > -1)
                                    let mobile = (t.mobile != null && t.mobile.toLowerCase().indexOf(searchValue.toLowerCase()) > -1);
                                    let childList = t.childList.some((x) => x.patientName != null && x.patientName.toLowerCase().indexOf(searchValue.toLowerCase()) > -1);
                                    if (childList) {
                                        t.isViewChild = true;
                                    }
                                    if (patientName || gender || cityName || email || mobile || childList) {
                                        return t;
                                    }
                                })
                                this.total = this.reports.length;
                            } else {
                                this.getPatientsList();
                            }
                        }
                    },
                    (error) => {
                        this.statusMessage = "Problem with the service. Please try again after sometime";
                        console.log(error);
                    }
                );
        }
    }

    CancelAppointments(aptdetails) {
        this.selectedTab = 'Complete appointments'
        this.reports = [];
        this.isdisplaysearch = false;
        this.isViewappointment = false;
        this.isAppointmentDetailReport = true;
        this.isViewTransactions = false;
        this.isViewUsers = false;
        this.isViewStaffs = false;
        this.isViewPatients = false;
        this.headerText = "";
        this.headerText = "All Appointments Details";
        aptdetails.appointmentStatus = "2";

        let confimationMessage = "Are you sure want to cancel  " + aptdetails.patientName + " appointment";
        if (confirm(confimationMessage)) {
            console.log('confirm msg ', confimationMessage);
            this.modalService.open('confirm', aptdetails);

        }

    }

    viewChild(data) {
        debugger
        if (data.isViewChild) {
            data.isViewChild = false;
        }
        else {
            data.isViewChild = true;
        }
    }

    sideBarToggle() {
        if (this.isSlide) {
            this.isSlide = false;
        }
        else {
            this.isSlide = true;
        }

    }

    generateExcel(reportType: any) {
        // debugger;
        console.log('arg ', reportType);
        if (!this.isViewappointment) {
            if (this.isViewPatients) {
                this.excelService.exportAsPatientExcelFile(this.reports, "report");
            }
            else {
                console.log('report ', this.reports);
                for (let index = 0; index < this.reports.length; index++) {
                    if (reportType == 'transcation') {
                        if (this.reports[index].transactionref == "" || this.reports[index].transactionref == null) {
                            this.reports[index].transactionref = 'N/A';
                        }
                        if (this.reports[index].customername == "" || this.reports[index].customername == null) {
                            this.reports[index].customername = 'N/A';
                        }
                        if (this.reports[index].customercredit == "" || this.reports[index].customercredit == null) {
                            this.reports[index].customercredit = 'N/A';
                        }
                        if (this.reports[index].transactionsettlementdate == "" || this.reports[index].transactionsettlementdate == null) {
                            this.reports[index].transactionsettlementdate = 'N/A';
                        }
                        if (this.reports[index].transactionrollingreservedate == "" || this.reports[index].transactionrollingreservedate == null) {
                            this.reports[index].transactionrollingreservedate = 'N/A';
                        }
                        if (this.reports[index].customercountry == "" || this.reports[index].customercountry == null) {
                            this.reports[index].customercountry = 'N/A';
                        }
                        if (this.reports[index].customeraddress == "" || this.reports[index].customeraddress == ' ' || this.reports[index].customeraddress == null) {
                            this.reports[index].customeraddress = 'N/A';
                        }
                        if (this.reports[index].customercity == "" || this.reports[index].customercity == null) {
                            this.reports[index].customercity = 'N/A';
                        }
                        if (this.reports[index].customerzip == "" || this.reports[index].customerzip == null) {
                            this.reports[index].customerzip = 'N/A';
                        }
                        if (this.reports[index].accref == "" || this.reports[index].accref == null) {
                            this.reports[index].accref = 'N/A';
                        }
                        if (this.reports[index].fraudalert == "" || this.reports[index].fraudalert == null) {
                            this.reports[index].fraudalert = 'N/A';
                        }
                        if (this.reports[index].fraudalert == " ") {
                            this.reports[index].fraudalert = 'N/A';
                        }
                        if (this.reports[index].fraudexplnation == "" || this.reports[index].fraudexplnation == " ") {
                            this.reports[index].fraudexplnation = 'N/A';
                        }
                        if (this.reports[index].createddatetime == null || this.reports[index].createddatetime == "") {
                            this.reports[index].createddatetime = 'N/A';
                        }
                        if (this.reports[index].customercredittype == null || this.reports[index].customercredittype == "") {
                            this.reports[index].customercredittype = 'N/A';
                        }
                        if (this.reports[index].customerphone == null || this.reports[index].customerphone == "") {
                            this.reports[index].customerphone = 'N/A';
                        }
                        if (this.reports[index].mobilepaymentrequest == null || this.reports[index].mobilepaymentrequest == "") {
                            this.reports[index].mobilepaymentrequest = 'N/A';
                        }
                        if (this.reports[index].result == null || this.reports[index].result == "") {
                            this.reports[index].result = 'N/A';
                        }
                        if (this.reports[index].resultexplanation == null || this.reports[index].resultexplanation == "") {
                            this.reports[index].resultexplanation = 'N/A';
                        }
                        if (this.reports[index].transactionamount == null || this.reports[index].transactionamount == "") {
                            this.reports[index].transactionamount = 'N/A';
                        }
                        if (this.reports[index].transactionapproval == null || this.reports[index].transactionapproval == "") {
                            this.reports[index].transactionapproval = 'N/A';
                        }
                        if (this.reports[index].transactioncurrency == null || this.reports[index].transactioncurrency == "") {
                            this.reports[index].transactioncurrency = 'N/A';
                        }
                        if (this.reports[index].transactiondate == null || this.reports[index].transactiondate == "") {
                            this.reports[index].transactiondate = 'N/A';
                        }
                        if (this.reports[index].transactionnetamount == null || this.reports[index].transactionnetamount == "") {
                            this.reports[index].transactionnetamount = 'N/A';
                        }
                        if (this.reports[index].transactionrollingreserveamount == null || this.reports[index].transactionrollingreserveamount == "") {
                            this.reports[index].transactionrollingreserveamount = 'N/A';
                        }
                        if (this.reports[index].transactiontoken == null || this.reports[index].transactiontoken == "") {
                            this.reports[index].transactiontoken = 'N/A';
                        }

                    }
                    else if (this.sectionType == 'appointments') {
                        console.log('this.reports[index] ', this.reports[index]);
                        if (this.reports[index].mobile == '' || this.reports[index].mobile == null) {
                            this.reports[index].mobile = 'N/A';
                        }
                        if (this.reports[index].appointmentEndTime == '' || this.reports[index].appointmentEndTime == null) {
                            this.reports[index].appointmentEndTime = 'N/A';
                        }
                        if (this.reports[index].appointmentId == '' || this.reports[index].appointmentId == null) {
                            this.reports[index].appointmentId = 'N/A';
                        }
                        if (this.reports[index].appointmentStartDate == '' || this.reports[index].appointmentStartDate == null) {
                            this.reports[index].appointmentStartDate = 'N/A';
                        }
                        if (this.reports[index].appointmentStartTime == '' || this.reports[index].appointmentStartTime == null) {
                            this.reports[index].appointmentStartTime = 'N/A';
                        }
                        if (this.reports[index].appointmentStatus == '' || this.reports[index].appointmentStatus == null) {
                            this.reports[index].appointmentStatus = 'N/A';
                        }
                        if (this.reports[index].doctorName == '' || this.reports[index].doctorName == null) {
                            this.reports[index].doctorName = 'N/A';
                        }
                        if (this.reports[index].email == '' || this.reports[index].email == null) {
                            this.reports[index].email = 'N/A';
                        }
                        if (this.reports[index].isDraft == '' || this.reports[index].isDraft == null) {
                            this.reports[index].isDraft = 'N/A';
                        }
                        if (this.reports[index].isFirstAvailable == '' || this.reports[index].isFirstAvailable == null) {
                            this.reports[index].isFirstAvailable = 'N/A';
                        }
                        if (this.reports[index].ondemandAvailability == '' || this.reports[index].ondemandAvailability == null) {
                            this.reports[index].ondemandAvailability = 'N/A';
                        }
                        if (this.reports[index].patientAge == '' || this.reports[index].patientAge == null) {
                            this.reports[index].patientAge = 'N/A';
                        }
                        if (this.reports[index].patientId == '' || this.reports[index].patientId == null) {
                            this.reports[index].patientId = 'N/A';
                        }
                        if (this.reports[index].patientName == '' || this.reports[index].patientName == null) {
                            this.reports[index].patientName = 'N/A';
                        }
                        if (this.reports[index].profileImage == '' || this.reports[index].profileImage == null) {
                            this.reports[index].isDraft = 'N/A';
                        }
                        if (this.reports[index].videoAvailability == '' || this.reports[index].videoAvailability == null) {
                            this.reports[index].videoAvailability = 'N/A';
                        }
                        if (this.reports[index].voiceAvailability == '' || this.reports[index].voiceAvailability == null) {
                            this.reports[index].voiceAvailability = 'N/A';
                        }

                    }

                }
                this.excelService.exportAsExcelFile(this.reports, "report");
            }
        }
        else {
            console.log('else block ', this.todayAppointmentList);
            // this.todayAppointmentList;
            for (let index = 0; index < this.todayAppointmentList.length; index++) {
                if (this.todayAppointmentList[index].mobile == '' || this.todayAppointmentList[index].mobile == null) {
                    this.todayAppointmentList[index].mobile == 'N/A';
                }
                if (this.todayAppointmentList[index].appointmentEndTime == '' || this.todayAppointmentList[index].appointmentEndTime == null) {
                    this.todayAppointmentList[index].appointmentEndTime == 'N/A';
                }
            }
            this.excelService.exportAsExcelFile(this.todayAppointmentList, "report");
        }
    }



}



// WEBPACK FOOTER //
// ./src/app/admin/deshboard/deshboard.component.ts